import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class PersonService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/tag/persons`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/tag/persons`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deletePersons = async (ids: number[]): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/persons/tag/${ids}`);
    return response.status === 204;
  };
}

export default PersonService;
